module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.d8de52e6.ttf";